import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import Footer from "@/components/Footer";
import NewsHero from "@/components/NewsHero";
import NewsCard from "@/components/NewsCard";
import { newsArticles } from "@/data/newsData";

const News = () => {
  // Sort articles by date, newest first
  const sortedArticles = [...newsArticles].sort((a, b) => b.date.getTime() - a.date.getTime());

  return (
    <>
      <Helmet>
        <title>News & Insights | AI-labbet</title>
        <meta name="description" content="Latest news and insights from AI-labbet on AI trends, regulations, best practices, and industry developments." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="News" />
        <main>
          <NewsHero />
          
          <section className="py-20 px-6">
            <div className="container mx-auto max-w-7xl">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sortedArticles.map((article) => (
                  <NewsCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default News;